module.exports = __webpack_public_path__ + "flyer_background_scattered_white_068-82b13e331147a45eec8ebeecb905e5d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_scattered_white_068.jpg
// module id = 1687
// module chunks = 1